// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
  font-size: 1.5rem;
}

.center-text-button {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
}

.link {
  text-decoration: underline;
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/app/main/pages/authentication/register/register.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,0BAAA;EACA,UAAA;AACJ","sourcesContent":[".icon {\n    font-size: 1.5rem;\n}\n\n.center-text-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    width: 100%;\n}\n\n.link {\n    text-decoration: underline;\n    color: red;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
